<template>
  <v-layout>
    <div class="col">
      <v-store-user-info/>
      <payment-breadcrumb :step="3"/>
      <article>
        <header>
          <h1>{{ $t(`confirmation.title.${status}`) }}</h1>
        </header>
        <div class="inner">
          <p>{{ $t(`confirmation.text.${status}`) }}</p>
          <v-store-user-invoice-form v-if="isStoreUser" :order="order" />
          <a class="button" href="https://www.ov-chipkaart.nl/servicepuntenzoeker">
            {{ $t('confirmation.button.charging-station') }}
          </a>
          <div class="linklist">
            <ul>
              <li><a href="http://www.arriva.nl">{{ $t('confirmation.button.to-arriva') }}</a></li>
              <li>
                <router-link :to="{name: overviewRoute, params: {lang: 'nl'} }">
                  {{ $t('confirmation.button.to-product-overview') }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </article>
    </div>
  </v-layout>
</template>

<script>
import authenticationMixin from '../mixins/authentication'
import VLayout from '../layouts/PaymentFlow'
import VStoreUserInfo from '../components/user/StoreUserInfo'
import PaymentBreadcrumb from '../components/PaymentBreadcrumb'
import VStoreUserInvoiceForm from '../components/payment-confirmation/StoreUserInvoiceActions'
import { ORDER_STATUS_AWAITING_PAYMENT } from '../order-api/order-api-client-constants'
import { mapGetters } from 'vuex'

export default {
  name: 'PaymentConfirmationPage',
  components: {
    VLayout,
    VStoreUserInfo,
    PaymentBreadcrumb,
    VStoreUserInvoiceForm
  },
  mixins: [
    authenticationMixin
  ],
  data: function () {
    return {
      status: ORDER_STATUS_AWAITING_PAYMENT,
      order: null
    }
  },
  computed: {
    ...mapGetters({
      overviewRoute: 'cart/overviewRoute'
    })
  },
  beforeMount: function () {
    this.status = this.$store.state.cart.orderStatus.status

    // Create internal copy of created order because it will be empty after clearOnConfirmation
    this.order = { ...this.$store.state.cart.order }

    this.$store.dispatch('clearOnConfirmation')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PaymentConfirmation.vue